import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
  selector: '[appPreventDoubleClick]'
})
export class PreventDoubleClickDirective  implements OnInit, OnDestroy{
  @Input() debounceTime = 1000;
  @Output() debounceClick = new EventEmitter();

  private clicks = new Subject();
  private subscription: Subscription = new Subscription();
  
  constructor() { }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  ngOnInit(): void {
    this.subscription = this.clicks.pipe(
      debounceTime(this.debounceTime)
    ).subscribe(e => {
    this.debounceClick.emit(e)
  });
  }

  @HostListener('click', ['$event'])
  clickEvent(event:any) {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }
}
